const state = {
  year: 2019,
  theme: '梦想和远方',
  avatar: 'Innei'
}

export default { state }
